var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('remote-js',{attrs:{"js-url":"https://www.yunpian.com/static/official/js/libs/riddler-sdk-0.2.2.js","js-load-call-back":_vm.loadRongJs}}),_c('div',{attrs:{"id":"cbox"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }